/* MooMenn-owned accessibility helpers. No tracking, account or cross-store redirects. */
(() => {
  if (window.moomennAccessibilityReady) return;
  window.moomennAccessibilityReady = true;
  const labels = {
    de: (v) => `${v} Artikel`,
    en: (v, n) => `${v} ${n === 1 ? 'item' : 'items'}`,
    es: (v, n) => `${v} ${n === 1 ? 'artículo' : 'artículos'}`,
    fr: (v, n) => `${v} ${n === 1 ? 'article' : 'articles'}`,
    it: (v, n) => `${v} ${n === 1 ? 'articolo' : 'articoli'}`,
    nl: (v, n) => `${v} ${n === 1 ? 'artikel' : 'artikelen'}`
  };
  const update = (element) => {
    const text = element.textContent.trim();
    const match = text.match(/\d+/);
    if (!match) return;
    const language = document.documentElement.lang.slice(0, 2).toLowerCase();
    const value = match[0] + (text.includes('+') ? '+' : '');
    element.setAttribute('aria-label', (labels[language] || labels.en)(value, Number(match[0])));
  };
  const bind = (element) => {
    if (element.dataset.mmCountObserved) return;
    element.dataset.mmCountObserved = 'true';
    update(element);
    new MutationObserver(() => update(element)).observe(element, {childList: true, characterData: true, subtree: true});
  };
  const brokenJudgeMeProductImageTokens = [
    'CZY_0421copie_4c839d91-7994-4812-9015-54fd19587bf6.jpg',
    'EmptyName46_fcab0b6e-af95-4947-8cf9-63a5ea9acdbd.jpg',
    'DSCF5284copie_85c2d985-8013-4b2f-ba78-3ad93383c53b.jpg',
    'DSCF8946_f5944cca-9594-4087-8b0d-d1da49ec958f.jpg',
    'DSCF9181_copie_cae95814-706b-4124-bfbe-64f42e67e274.jpg',
    'czy_12950copie_2f93c844-f202-4093-8e10-407788f01337.jpg',
    'DSCF5210copie_dab2ddff-6612-4987-bfc0-b6051dd53790.jpg'
  ];
  const hideBrokenJudgeMeProductThumbnail = (image) => {
    if (!document.body.classList.contains('judgeme_all_reviews')) return;
    if (!brokenJudgeMeProductImageTokens.some((token) => image.currentSrc.includes(token) || image.src.includes(token))) return;
    const thumbnail = image.closest('.jm-product-variant-card__thumbnail');
    if (!thumbnail) return;
    thumbnail.hidden = true;
    thumbnail.style.display = 'none';
    thumbnail.dataset.mmBrokenJudgeMeThumbnailHidden = 'true';
  };
  // Exact IGO Sky Blue review UUID from retained 29 Sep 2026 mapping.
  // Keep Judge.me review data and visible product names intact; only retire dead actions.
  const retiredReviewIdsByPath = {
    '/products/ql-igo-relaxed-cargo-shorts-and-t-shirt-set-in-sky-blue': [
      '48b8caea-84c3-47ca-b29a-c50d324277b7'
    ]
  };
  const retiredReviewIds = new Set(Object.values(retiredReviewIdsByPath).flat());
  const retiredReviewCardSelector = '.jm-review-item[review-uuid]';
  const retiredProductControlSelector = '.jm-product-variant-card__product-link, .jm-product-variant-card__thumbnail';
  const preventRetiredProductNavigation = (event) => {
    if (event.type !== 'click' && !['Enter', ' '].includes(event.key)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  };
  const retireReviewProductActions = (root) => {
    if (!document.body.classList.contains('judgeme_all_reviews')) return;
    const cards = new Set(root.querySelectorAll?.(retiredReviewCardSelector) || []);
    if (root.matches?.(retiredReviewCardSelector)) cards.add(root);
    const ancestor = root.closest?.(retiredReviewCardSelector);
    if (ancestor) cards.add(ancestor);
    cards.forEach((card) => {
      if (!card.closest('.jdgm-all-reviews-widget-v2025')) return;
      if (!retiredReviewIds.has(card.getAttribute('review-uuid'))) return;
      card.querySelectorAll(retiredProductControlSelector).forEach((control) => {
        control.removeAttribute('role');
        control.removeAttribute('tabindex');
        control.removeAttribute('aria-label');
        control.style.cursor = 'default';
        if (control.dataset.mmRetiredReviewProductAction) return;
        control.dataset.mmRetiredReviewProductAction = 'true';
        control.addEventListener('click', preventRetiredProductNavigation, true);
        control.addEventListener('keydown', preventRetiredProductNavigation, true);
      });
    });
  };
  const reviewNames = {
    fr: {
      sort: 'Trier les avis par',
      product: (title) => `Voir la page du produit ${title}`,
      close: 'Fermer le formulaire d’avis',
      rating: (stars, count, percent) => `${percent} % (${count}) avis avec ${stars} étoile${stars === 1 ? '' : 's'}`
    },
    de: {
      sort: 'Bewertungen sortieren nach',
      product: (title) => `Produktseite für ${title} anzeigen`,
      close: 'Bewertungsformular schließen',
      rating: (stars, count, percent) => `${percent} % (${count}) Bewertungen mit ${stars} Stern${stars === 1 ? '' : 'en'}`
    },
    nl: {
      sort: 'Beoordelingen sorteren op',
      product: (title) => `Productpagina van ${title} bekijken`,
      close: 'Beoordelingsformulier sluiten',
      rating: (stars, count, percent) => `${percent}% (${count}) beoordelingen met ${stars} ster${stars === 1 ? '' : 'ren'}`
    }
  };
  const localizeJudgeMeReviewNames = (root) => {
    if (!document.body.classList.contains('judgeme_all_reviews')) return;
    const names = reviewNames[document.documentElement.lang.slice(0, 2).toLowerCase()];
    if (!names) return;
    const widget = document.querySelector('.jdgm-all-reviews-widget-v2025');
    if (!widget) return;
    const select = (selector) => {
      const matches = root.matches?.(selector) ? [root] : [];
      return matches.concat([...root.querySelectorAll?.(selector) || []]);
    };
    select('.jm-histogram-row[role="button"]').forEach((row) => {
      if (!widget.contains(row)) return;
      const stars = Number(row.querySelector('.jm-histogram-row__rating')?.textContent.trim());
      const count = row.querySelector('.jm-histogram-row__frequency')?.textContent.trim();
      const percent = row.querySelector('.jm-progress-bar__fill')?.style.width.match(/^\d+(?:\.\d+)?(?=%$)/)?.[0];
      if (stars >= 1 && stars <= 5 && count && percent) {
        const label = names.rating(stars, count, percent);
        if (row.getAttribute('aria-label') !== label) row.setAttribute('aria-label', label);
      }
    });
    select('label[for^="jdgm-sort-"]').forEach((label) => {
      if (widget.contains(label) && label.textContent !== names.sort) label.textContent = names.sort;
    });
    select('.jm-product-variant-card__product-link[role="button"], .jm-product-variant-card__thumbnail[role="button"]')
      .forEach((button) => {
        if (!widget.contains(button)) return;
        const title = button.matches('.jm-product-variant-card__thumbnail')
          ? button.querySelector('img')?.getAttribute('alt')?.trim()
          : button.textContent.trim();
        if (title) {
          const label = names.product(title);
          if (button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
        }
      });
    select('.jdgm-write-review-modal [aria-label="Close review form"]').forEach((button) => {
      if (button.getAttribute('aria-label') !== names.close) button.setAttribute('aria-label', names.close);
    });
  };
  const scan = (root) => {
    if (root.matches?.('cart-count')) bind(root);
    root.querySelectorAll?.('cart-count').forEach(bind);
    const selector = 'a.jdgm-medal[aria-label]';
    const medals = root.matches?.(selector) ? [root] : root.querySelectorAll?.(selector) || [];
    medals.forEach((link) => {
      const text = link.textContent.trim();
      const label = link.getAttribute('aria-label') || '';
      if (text && !label.includes(text)) link.setAttribute('aria-label', `${label} (${text})`);
    });
    const images = root.matches?.('img') ? [root] : root.querySelectorAll?.('img') || [];
    images.forEach(hideBrokenJudgeMeProductThumbnail);
    localizeJudgeMeReviewNames(root);
    retireReviewProductActions(root);
  };
  const initialize = () => {
    scan(document);
    new MutationObserver((records) => {
      records.forEach(({addedNodes, type, target}) => {
        if (type === 'attributes' && target instanceof Element) scan(target);
        addedNodes.forEach((node) => {
          if (node instanceof Element) scan(node);
        });
      });
    }).observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['aria-label', 'role', 'tabindex']});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once: true});
  else initialize();
})();
